import React, { useEffect, useState } from 'react'
import { useDatabase } from '../../contexts/DatabaseContext'

export default function CarSettings({ index, car }) {

    const [newSettings, setNewSettings] = useState(car)
    const [saving, setSaving] = useState(false)

    const { updateCar } = useDatabase()

    const handleCarChange = (index, e) => {
        const { name, value } = e.target;
        setNewSettings(prevSettings => ({
            ...prevSettings,
            [name]: value
        }));
    }

    async function handleSaveCar() {
        setSaving(true)
        await updateCar(car.id, newSettings)
        setSaving(false)
    }

    useEffect(() => {
        console.log(car)
        console.log(newSettings)
    })

    return (
        <div key={index} className="tab mx-1">
            <div className="card w-100 m-auto">
                <div className="card-header">
                    <h4 className="card-title">Car: {newSettings?.car_name || 'My Car'}</h4>
                </div>
                <div className="card-body">
                    <div className="form-group my-3">
                        <label htmlFor="car_name">Car Name</label>
                        <input
                            type="text"
                            className="form-control"
                            name="car_name"
                            value={newSettings?.car_name || 'My Car'}
                            onChange={(e) => handleCarChange(index, e)}
                            placeholder="Car Name"
                        />
                    </div>

                    <div className="form-group my-3">
                        <label htmlFor="dweet_name">Dweet Thing Name</label>
                        <input
                            type="text"
                            className="form-control"
                            name="dweet_name"
                            value={newSettings?.dweet_name || ''}
                            onChange={(e) => handleCarChange(index, e)}
                            placeholder="Dweet Thing Name"
                        />
                    </div>

                    <div className="form-group my-3">
                        <label htmlFor="battery_capacity">Battery Capacity (Ah)</label>
                        <input
                            type="number"
                            className="form-control"
                            name="battery_capacity"
                            value={newSettings?.battery_capacity || 25}
                            onChange={(e) => handleCarChange(index, e)}
                            placeholder="Battery Capacity"
                        />
                    </div>

                    <div className="form-group my-3">
                        <label htmlFor="reverse_gearing_mode">Reverse Gearing Mode</label>
                        <select
                            className="form-control"
                            name="reverse_gearing_mode"
                            value={newSettings?.reverse_gearing_mode || 'false'}
                            onChange={(e) => handleCarChange(index, e)}
                        >
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                        </select>
                    </div>

                    <div className="form-group my-3">
                        <label htmlFor="motor_gear_teeth">Number of teeth on motor gear</label>
                        <input
                            type="number"
                            className="form-control"
                            name="motor_gear_teeth"
                            value={newSettings?.motor_gear_teeth || 20}
                            onChange={(e) => handleCarChange(index, e)}
                            placeholder="Motor Gear Teeth"
                        />
                    </div>

                    <div className="form-group my-3">
                        <label htmlFor="axle_gear_teeth">Number of teeth on axle gear</label>
                        <input
                            type="number"
                            className="form-control"
                            name="axle_gear_teeth"
                            value={newSettings?.axle_gear_teeth || 60}
                            onChange={(e) => handleCarChange(index, e)}
                            placeholder="Axle Gear Teeth"
                        />
                    </div>

                    <div className="form-group my-3">
                        <label htmlFor="gear_number_offset">Gear Number Offset</label>
                        <br></br>
                        <small>You can adjust this if your gear number is showing consistently off.</small>
                        <input
                            type="number"
                            className="form-control"
                            name="gear_number_offset"
                            value={newSettings?.gear_number_offset || 0}
                            onChange={(e) => handleCarChange(index, e)}
                            placeholder="Gear Number Offset"
                        />
                    </div>

                    <div className="form-group my-3">
                        <label htmlFor="battery_offset">Battery Offset</label>
                        <br></br>
                        <small>You can adjust this if you accidently reset the Amp Hours used during the race.</small>
                        <input
                            type="number"
                            className="form-control"
                            name="battery_offset"
                            value={newSettings?.battery_offset || 0}
                            onChange={(e) => handleCarChange(index, e)}
                            placeholder="Battery Offset"
                        />
                    </div>
                    <button class="btn btn-primary" type="button" onClick={handleSaveCar}>Save</button>
                </div>
            </div>
        </div>
    )
}
